import dateUtilMixins from "@/components/echarts-part/TableChart/mixins/date-util-mixins";

export const AGGREGATION = {
    SUM: 'SUM',
    AVG: 'AVG',
    MIN: 'MIN',
    MAX: 'MAX'
}

export default {
    mixins: [dateUtilMixins],
    computed: {
        $_xAxisFields() {
            return [];
        },
        $_dateSplitUnit() {
            return -1;
        },
        isXAxisTypeDate() {
            return this.getXAxisType(this.$_xAxisFields);
        },
        isXAxisTimeSplit() {
            return this.getIsTimeSplit(this.$_dateSplitUnit);
        },
    },
    methods: {
        //Translate label if exist
        fieldLabel(item) {
            let label = this.$t(item.label);
            if (!label) {
                label = item.key;
            }
            return label;
        },
        getXAxisType(xAxisFields) {
            let tag;
            for (let f of xAxisFields) {
                let temp = this.isFieldTypeDate(f);
                if (tag === undefined) {
                    tag = temp;
                } else if (tag !== temp) {
                    return null;
                }
            }
            return tag;//true ? 'time' : 'category'
        },
        getIsTimeSplit(splitUnit) {
            return splitUnit > -1;
        },
        isFieldTypeDate(item) {
            return this.itemTypeIn(item, ['datetimepicker', 'datepicker', 'year_month', 'hour_minute']);
        },
        isFieldTypeString(item) {
            return this.itemTypeIn(item, ['input', 'select', 'entitySelect', 'scheduledPeriodicUnit']);
        },
        isFieldGrouped(field) {
            return field.groupBy && field.groupBy.fields && field.groupBy.fields.length > 0;
        },
        itemTypeIn(item, list) {
            return list.some(f => f === item.form.type);
        },
        removeField(list, index) {
            list.splice(index, 1);
        },
        //Trigger by key. If list contains then remove item, or push
        changeAxisFieldList(list, item) {
            let has = false;
            for (let i = 0; i < list.length; i++) {
                if (list[i].key === item.key) {
                    list.splice(i, 1);
                    has = true;
                    break;
                }
            }
            if (!has) {
                list.push(item);
            }
            this.cancelHideTag = true;
        },
        isFieldSelected(list, item) {
            return list.some(f => f.key === item.key);
        },
        /**
         * 将输入转化为数字
         * 1,如果是数字就返回自己
         * 2,如果是日期就返回 milliseconds
         */
        getNumberValue(val) {
            if (val) {
                if (!isNaN(val)) {
                    return Number.parseFloat(val);
                } else {
                    let millisecond = Date.parse(val);
                    if (!isNaN(millisecond)) {
                        return millisecond;
                    }
                }
            }
            return null;
        },
    }
}
